import axios from 'axios';
import { useEffect, useState } from 'react';
import { Alert, CircularProgress } from '@mui/material';
import { useAuthorizationContext } from '../context/AuthorizationContext';
import TodayScheduleModal from './TodayScheduleModal';

const NextBusDeparture = ({ lineId, vehiclesPosition }) => {
  const day = new Date().getDay();
  const { jwt, headers, getAuthToken } = useAuthorizationContext();
  const [loading, setLoading] = useState(true);
  const [initialLoad, setInitialLoad] = useState(true);
  const [busDepartureTimes, setBusDepartureTimes] = useState([]);
  const [nextBusDeparture, setNextBusDeparture] = useState();
  
  const stopId = '001';

  const getSchedule = async () => {
    setLoading(true);
    try {
      let tripTimes = [];
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/schedule/${stopId}/day/${day}`, { headers });
      for (const trip of data) {
        if (trip.lineCode === lineId) {
          // setBusDepartureTimes((current) => [...current, trip.tripTime]);
          tripTimes.push(trip.tripTime);
        }
      }
      if (tripTimes.length === 0) {
        setBusDepartureTimes([]);
        setNextBusDeparture();
      } else {
        setBusDepartureTimes(tripTimes);
      }
    } catch (error) {
      console.log(error);

      // handle authorization error
      if (error.request.status === 401) {
        getAuthToken();
      }
    }
    setLoading(false);
    setInitialLoad(false);
  };

  const checkTimeForNextBusDeparture = () => {
    let today = new Date();
    let time;
    for (const trip of busDepartureTimes) {
      time = trip.split(':');
      let tripTime = new Date();
      tripTime.setHours(time[0]);
      tripTime.setMinutes(time[1]);
      if (tripTime > today) {
        setNextBusDeparture(trip);
        break;
      } else if (tripTime < today) {
        setNextBusDeparture();
      }
    }
  };


  useEffect(() => {
    getSchedule();
  }, [lineId, jwt]);

  useEffect(() => {
    checkTimeForNextBusDeparture();
    console.log('updating next bus departure time');
  }, [busDepartureTimes, vehiclesPosition, lineId]);

  if (initialLoad) {
    return <CircularProgress></CircularProgress>;
  }

  return (
    <>
      <div className='info-container'>
        <Alert severity='info'>
          {nextBusDeparture ? (
            <>
              Next Bus Departure At: <strong> {nextBusDeparture}</strong>
              <TodayScheduleModal loading={loading} schedule={busDepartureTimes}></TodayScheduleModal>
            </>
          ) : (
            <>
              No more trips for the rest of the day
              <TodayScheduleModal loading={loading} schedule={busDepartureTimes}></TodayScheduleModal>
            </>
          )}
        </Alert>
      </div>
    </>
  );
};

export default NextBusDeparture;
